import { render } from "./FileTree.vue?vue&type=template&id=5daac7b6"
import script from "./FileTree.vue?vue&type=script&lang=js"
export * from "./FileTree.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FileTree.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5daac7b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5daac7b6', __exports__)) {
    api.reload('5daac7b6', __exports__)
  }
  
  module.hot.accept("./FileTree.vue?vue&type=template&id=5daac7b6", () => {
    api.rerender('5daac7b6', render)
  })

}


export default __exports__